import { DbrEventEntity } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace EventsStateActions {
  export class SetEvents {
    static readonly type = '[Balloons] SetEvents';

    constructor(public events: DbrEventEntity[]) {
    }
  }

  export class SetEvent {
    static readonly type = '[Balloons] SetEvent';

    constructor(public event: DbrEventEntity) {
    }
  }

  export class SetActiveEventId {
    static readonly type = '[Balloons] SetActiveEventId';

    constructor(public activeEventId: number | null) {
    }
  }
}
